export default function VipStatCard({ title, value, subtitle }) {
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm border">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <h3 className="text-2xl font-bold mt-1">{value}</h3>
          <p className="text-xs text-gray-400 mt-1">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
